import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "../lifehacks/ArticleFull.css";

import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const locations = [
  {
    name: "Ponto das Canas",
    url: "https://maps.app.goo.gl/5rwj48rUYWvjFWRm9",
    description:
      "Живописный пляж в районе Канасвиейрас, идеальный для спокойного отдыха и закатов.",
    position: [-27.395584002704304, -48.43326498068511], 
  },
  {
    name: "Morro do Rapa",
    url: "https://maps.app.goo.gl/8XMNXTQa6pSa1S3X6",
    description:
      "Смотровая площадка с панорамным видом на океан, популярная для прогулок.",
    position: [-27.38396045948799, -48.41937123565255], 
  },
  {
    name: "Dunas do Santinho Norte",
    url: "https://goo.gl/maps/J7FGdmonJQTVJeyX8",
    description:
      "Песчаные дюны в северной части пляжа Сантинью, отличное место для сэндбординга.",
    position: [-27.449131233335766, -48.36833954631724], 
  },
  {
    name: "Santinho Sul Aranhas",
    url: "https://maps.app.goo.gl/Dc6wWwKtaFEk2evf9",
    description:
      "Уединённый участок пляжа Сантинью с мощными волнами, привлекающий серферов.",
    position: [-27.468215330995424, -48.3761498306851], 
  },
  {
    name: "Praia do Moçambique",
    url: "https://maps.app.goo.gl/GDYNekBv8WcmCnKs6",
    description:
      "Самый длинный пляж Флорипы, окружённый сосновым лесом, идеален для прогулок.",
    position: [-27.52294366527982, -48.41680341534254], 
  },
  {
    name: "Daniela Pontal",
    url: "https://maps.app.goo.gl/mqURsdKPsR5Dk8fMA",
    description:
      "Спокойный пляж с мелководьем, подходящий для семейного отдыха с детьми.",
    position: [-27.458769377967158, -48.54618441534255], 
  },
  {
    name: "Sambaqui Ponto",
    url: "https://maps.app.goo.gl/HQ2ViYYnKvE36TLG8",
    description:
      "Тихая рыбацкая деревня с потрясающими видами на залив и свежими морепродуктами.",
    position: [-27.49070634139602, -48.53881535767127], 
  },
  {
    name: "Barra da Lagoa",
    url: "https://maps.app.goo.gl/oxaEVvgLoXBxSVyx7",
    description:
      "Оживлённый пляж с рыбацким колоритом и каналом, соединяющим лагуну и океан.",
    position: [-27.573060388413733, -48.4216714558218], 
  },
  {
    name: "Dólmen do Oração Trilha",
    url: "https://maps.app.goo.gl/AYrbAnVnK8wkcEnv7",
    description:
      "Тропа к древним мегалитам с захватывающими видами на побережье.",
    position: [-27.5895004159381, -48.42891721534256], 
  },
  {
    name: "Parque Rio Vermelho",
    url: "https://maps.app.goo.gl/pt6StYgbMKz9fE7G9",
    description:
      "Природный парк с тропами и дикой природой, идеальный для экотуризма.",
    position: [-27.5265879429639, -48.42715302698616], 
  },
  {
    name: "Waterfall Costa da Lagoa Trilha",
    url: "https://maps.app.goo.gl/MxAtxk6GEqL8WexEA",
    description:
      "Живописная тропа к водопаду в районе Коста-да-Лагоа, окружённая зеленью.",
    position: [-27.543310986828732, -48.463798700000005], 
  },
  {
    name: "Parque Joaquina",
    url: "https://maps.app.goo.gl/bTdVAtGu5N48Whf29",
    description:
      "Парк рядом с пляжем Жоакина, популярный для прогулок и пикников.",
    position: [-27.63450039977597, -48.467779371164355], 
  },
  {
    name: "Morro da Cruz Mirante",
    url: "https://maps.app.goo.gl/WG2fXZpjzoGvrhYv6",
    description:
      "Смотровая площадка с видом на центр Флорианополиса и мост Эрсилиу-Луз.",
    position: [-27.58819623974872, -48.533815744178206], 
  },
  {
    name: "Hercílio Luz Bridge",
    url: "https://maps.app.goo.gl/Y6VzfEwmF3MVMsUU9",
    description:
      "Иконический подвесной мост, символ Флорипы, особенно красив в ночной подсветке.",
    position: [-27.593328241716538, -48.5616188], 
  },
  {
    name: "Praça XV de Novembro Centro",
    url: "https://maps.app.goo.gl/PKiNBUHjeSVGD3vv9",
    description:
      "Центральная площадь с историческим фиговым деревом и яркой городской атмосферой.",
    position: [-27.597300307205003, -48.54980964417819], 
  },
  {
    name: "Trilha do Poção Córrego Grande Centro",
    url: "https://maps.app.goo.gl/6r5cEbuHEbYzJvXa7",
    description:
      "Короткая тропа к природному бассейну, идеальная для освежающего купания.",
    position: [-27.610275655019976, -48.50667788650693], 
  },
  {
    name: "Mirante Morro Lampião",
    url: "https://maps.app.goo.gl/mpzRgpF5NkJD5d5x8",
    description:
      "Смотровая площадка в районе Кампече с видами на океан и остров Кампече.",
    position: [-27.67078161181551, -48.49303815582181], 
  },
  {
    name: "Armação, Ponta das Campanhas",
    url: "https://maps.app.goo.gl/wmakukyL8e1XXzsz9",
    description:
      "Пляж с исторической церковью и тропами к уединённым уголкам побережья.",
    position: [-27.748104671466187, -48.499112671164355], 
  },
  {
    name: "Lagoinha do Leste Morro da Coroa / Mirante",
    url: "https://maps.app.goo.gl/VV1BpG6KbG8YoNwT7",
    description:
      "Дикий пляж с лагуной, доступный через трек, с потрясающим видом с вершины.",
    position: [-27.782094264820234, -48.48907110184947], 
  },
  {
    name: "Restaurante Ostradamus, Ribeirão da Ilha",
    url: "https://maps.app.goo.gl/WA44959TCVr1ga4k8",
    description:
      "Знаменитый ресторан с лучшими устрицами и видами на рыбацкую деревню.",
    position: [-27.719827201085973, -48.56413502698616], 
  },
  {
    name: "Estacionamento Trilha dos Naufragados",
    url: "https://maps.app.goo.gl/DmNamC5v8LWwqHBaA",
    description:
      "Начало тропы к пляжу Науфрагадос с маяком и дикими пейзажами.",
    position: [-27.816127316924863, -48.56088899999999],
  },
  {
    name: "Cachoeira da Solidão Sul",
    url: "https://maps.app.goo.gl/19dHtFw49DKxEKcz5",
    description:
      "Уединённый водопад в южной части острова, окружённый тропическим лесом.",
    position: [-27.79394983359985, -48.53787624232873],
  },
  {
    name: "Mirante do Morro da Lagoa da Conceição",
    url: "https://maps.app.goo.gl/vP33YujN6PxCbeEFA",
    description:
      "Смотровая площадка с видом на лагуну Лагоа-да-Консейсао и дюны.",
    position: [-27.600503756966358, -48.481306113493076], 
  },
  {
    name: "Fundação Projeto TAMAR Florianópolis",
    url: "https://maps.app.goo.gl/V2rAUWsydun7kQZc9",
    description:
      "Центр защиты морских черепах с экскурсиями и образовательными программами.",
    position: [-27.571922096244723, -48.42785573068511], 
  },
  {
    name: "Corrego Grande Municipal Park",
    url: "https://maps.app.goo.gl/wqZn9cjGELTw5pkk6",
    description:
      "Городской парк с тропами, озером и зонами для отдыха в центре города.",
    position: [-27.599543123122505, -48.51089260239623], 
  },
  {
    name: "Pedras de Canasvieras",
    url: "https://maps.app.goo.gl/r32EFsMX561ywtdv7",
    description:
      "Скалистый участок пляжа Канасвиейрас, популярный для рыбалки и фото.",
    position: [-27.42623394998461, -48.472795171164364], 
  },
  {
    name: "Mirante da Brava",
    url: "https://maps.app.goo.gl/5Ey8VUzdjuFhFzZh7",
    description:
      "Смотровая площадка над пляжем Прайя-Брава с видами на бурные волны.",
    position: [-27.398330052650888, -48.41905828835639], 
  },
  {
    name: "Trilha Mirante Ingleses e Dunas",
    url: "https://goo.gl/maps/Aun74tQbmCdDPYHw9",
    description:
      "Тропа через дюны Инглесес к смотровой площадке с панорамой побережья.",
    position: [-27.443524743420905, -48.36596473282429],
  },
  {
    name: "Pizzaria Estrela da Ilha Sul",
    url: "https://maps.app.goo.gl/RFNuuW4ChoX33ugd7",
    description:
      "Популярная пиццерия в южной части острова с уютной атмосферой и местными блюдами.",
    position: [-27.693316253006866, -48.51014042883564], 
  },
  {
    name: "Trilha da Galheta",
    url: "https://maps.app.goo.gl/KuX8bKbjpskjdP5N9",
    description:
      "Тропа к уединённому пляжу Галета, известному своей природной красотой.",
    position: [-27.598299084527394, -48.42897589815053], 
  },
];

const FloripaLocationsGuide = () => {
  return (
    <div className="article-full">
      <h2 className="article-subtitle">Путеводитель по острову волшебства: Флорианополис</h2>
      <p><i>Материалы для статьи собраны и предоставлены Татьяной - <a href="https://floripa.live/specialist/rentcar-carro4you">Carro4you</a></i></p>
      <div className="article-section">
        <p className="article-text">
          Флорианополис, или Флорипа, — столица штата Санта-Катарина, расположенная на одноимённом острове в Бразилии. Известный как «Остров магии» (Ilha da Magia), он привлекает путешественников своими белоснежными пляжами, живописными лагунами, колониальной архитектурой и яркой культурой.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">Топ-30 мест Флорианополиса</h3>
        <p className="article-text">
          Флорипа предлагает множество мест: от диких пляжей до исторических достопримечательностей. Ниже — интерактивная карта и список локаций:
        </p>

      <div style={{ height: "500px", width: "100%", margin: "1rem 0", borderRadius: "8px" }}>
          <MapContainer
            center={[-27.5954, -48.5480]}
            zoom={10}
            style={{ height: "100%", width: "100%", borderRadius: "8px" }}
          >
            <TileLayer
              url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
              attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>'
            />
            {locations.map((location, index) => (
              <Marker key={index} position={location.position}>
                <Popup>
                  <div>
                    <h4>{location.name}</h4>
                    <p>{location.description}</p>
                    <a
                      href={location.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="article-link"
                    >
                      Посмотреть на Google Maps
                    </a>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

 
        {locations.map((location, index) => (
          <div key={index} className="article-text">
            <strong>
              {index + 1}. {location.name}:
            </strong>{" "}
            {location.description}{" "}
            <a
              href={location.url}
              target="_blank"
              rel="noopener noreferrer"
              className="article-link"
            >
              Посмотреть на карте
            </a>
          </div>
        ))}
        <div className="article-note">
          <p className="article-note-text">
            Для походов по тропам берите воду, удобную обувь, солнцезащитный крем и средство от москитов.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FloripaLocationsGuide;